import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import _ from 'lodash';
import React from 'react';
import { BLUE } from '../../../_config/consts';

const styles = {
  iconGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    marginTop: 10,
  },
  iconButton: {
    border: '1px solid transparent',
  },
  iconButtonHover: {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
  selectedIcon: {
    backgroundColor: BLUE,
    color: 'white',
  },
};

class IconSelectorField extends React.Component {
  getSelectedValues = () => {
    const { multiSelect = false, input } = this.props;
    const inputValue = input?.value;

    if (multiSelect) {
      return inputValue || [];
    }
    return inputValue || '';
  }

  isSelected = (iconValue) => {
    const { multiSelect = false } = this.props;
    const selectedValues = this.getSelectedValues();

    if (multiSelect) {
      return _.includes(selectedValues, iconValue);
    }
    return selectedValues === iconValue;
  }

  onHandleChange = (iconValue) => {
    const { multiSelect = false, input, onSelect } = this.props;
    const selectedValues = this.getSelectedValues();
    let newSelection;
    
    if (multiSelect) {
      newSelection = this.isSelected(iconValue)
        ? _.filter(selectedValues, value => !_.isEqual(value, iconValue))
        : _.concat(selectedValues, iconValue);
    } else {
      newSelection = this.isSelected(iconValue) ? '' : iconValue;
    }

    if (input) {
      input.onChange(newSelection);
    }
    
    if (onSelect) {
      onSelect(newSelection);
    }
  }

  render() {
    const { icons = [], title, mandatory, containerStyle, meta } = this.props;
    const hasError = meta.touched && meta.error;
    return (
      <div style={{...containerStyle}}>
        {title && <h4 style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 3, color: hasError ? 'red' : '#3f3f3f' }}>{title}{mandatory && <span style={{ color: 'red' }}>*</span>}</h4>}
        <Grid container style={styles.iconGrid}>
          {_.map(icons, (icon, index) => (
            <IconButton
              key={`icon-${index}`}
              onClick={() => this.onHandleChange(icon.value)}
              style={{
                ...styles.iconButton,
                ...(this.isSelected(icon.value) ? styles.selectedIcon : {}),
                ...(hasError ? { color: 'red' } : {}),
              }}
            >
              {icon.displayIconComponent}
            </IconButton>
          ))}
        </Grid>
      </div>
    );
  }
}

export default IconSelectorField; 